<template>
<div class="form-step-item step-1">
    <div class="panel">
        <h3>Select Formulation Type</h3>
        <h5 class="label">How will this formulation be used?</h5>
        <div class="formulation-form-row">
            <div class="form-group col-12 use-radio">
                <div class="bax-boxed-radio">
                    <div class="bax-radio">
                        <input type="radio" id="use_general" class="css-checkbox" value="general" v-model="formData.use" />
                        <label for="use_general" class="css-label">General stock - a formulation that your hospital / clinic will regularly use</label>
                    </div>
                    <div class="bax-radio">
                        <input type="radio" id="use_patient" class="css-checkbox" value="patient" v-model="formData.use" />
                        <label for="use_patient" class="css-label">Patient-specific - a formulation for a specific patient</label>
                    </div>
                </div>
                <span class="form-error" v-if="$v.formData.use.$dirty && !$v.formData.use.required">Required field</span>
            </div>
        </div>
    </div>
    <div class="panel">
        <h5 class="label">How often do you expect this formulation will be needed?</h5>
        <div class="formulation-form-row">
            <div class="form-group col-12">
                <div class="bax-boxed-radio">
                    <div class="bax-radio">
                        <input type="radio" id="frequency_once" class="css-checkbox" value="once" v-model="formData.frequency" />
                        <label for="frequency_once" class="css-label">Once-off</label>
                    </div>
                    <div class="bax-radio">
                        <input type="radio" id="frequency_regular" class="css-checkbox" value="regular" v-model="formData.frequency" />
                        <label for="frequency_regular" class="css-label">On a regular basis</label>
                    </div>
                </div>
                <span class="form-error" v-if="$v.formData.frequency.$dirty && !$v.formData.frequency.required">Required field</span>
            </div>
        </div>
    </div>
    <div class="navigation-container">
        <button type="button" class="bax-btn bax-btn-blue-brand" @click.prevent="onFormNext">Select formulation base</button>
    </div>
</div>
</template>
<script>

import { required } from 'vuelidate/lib/validators';

export default {
    name: 'FormStep1',
    props: {
        formData: {
            required: true,
        },
    },
    data() {
        return {
        };
    },
    validations: {
        formData: {
            use: {
                required,
            },
            frequency: {
                 required,
            },
        },
    },
    computed: {
    },
    methods: {
        onFormNext() {
            this.$v.$touch();
            this.$emit('validation_response', !this.$v.$invalid);
        },
    },
};
</script>
